import { connect } from "react-redux";
import { getRoutes } from "../../../../store/appInfo/getters";
import PlumLink from "../../../../commons/components/Elements/PlumLink";
import React from "react";

interface Props {
  buttonText: string;
  customClass: string;
  buttonTextColour: string;
  buttonColour: string;
  routes: string[];
}

const RedeemBtn: React.FC<Props> = (props) => {
  const { buttonText, customClass, buttonTextColour, buttonColour, routes } =
    props;
  const redirectURL = routes?.includes("vouchers") ? "vouchers" : "experiences";
  return (
    <PlumLink url={`/${redirectURL}`}>
      <div
        className={`mt-4 redeemBtn ${customClass ? customClass : ""}`}
        style={{
          backgroundColor: buttonColour,
          color: buttonTextColour,
        }}
      >
        <span>{buttonText}</span>
      </div>
    </PlumLink>
  );
};

const mapStateToProps = ({ appInfo }: any) => ({
  routes: getRoutes(appInfo),
});

export default connect(mapStateToProps)(RedeemBtn);
